import {
    isValidElement,
    cloneElement,
    Children,
    type FC
} from "react";
import {
    View
} from "react-native";
import type ISheetFooterProps from "./type";
import type {
    SheetFooterChildProps
} from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import {
    useSheetContext
} from "../../context";

const SheetFooter: FC<ISheetFooterProps> = ({
    align: alignProp,
    children,
    style,
    ...props
}) => {
    const sheet = useSheetContext({
        part: "Footer"
    });

    const {
        borders,
        colors,
        spaces
    } = NCoreUIKitTheme.useContext(sheet?.customTheme);

    const form = sheet?.form ?? "panel";

    const align = alignProp ?? (form === "bottom" ? "stretch" : "end");

    const {
        container: containerDynamicStyle
    } = useStyles({
        borders,
        colors,
        spaces,
        align,
        form
    });

    if(!sheet) {
        return null;
    }

    const renderChildren = () => {
        if(align !== "stretch") {
            return children;
        }

        return Children.map(children, (child) => {
            if(!isValidElement<SheetFooterChildProps>(child)) {
                return child;
            }

            return cloneElement(child, {
                style: [
                    child.props.style,
                    stylesheet.stretched
                ]
            });
        });
    };

    return <View
        {...props}
        style={[
            style,
            stylesheet.container,
            containerDynamicStyle
        ]}
    >
        {renderChildren()}
    </View>;
};
export default SheetFooter;
